import React, { type FC, type PropsWithChildren, useMemo } from 'react'
import { Link, type LinkProps } from '@mui/material'

import type { DocumentationType } from '../../application'

import { useAppUsecase } from './State'

type DocumentationLinkProps = Readonly<{ type: DocumentationType }> & Pick<LinkProps, 'sx' | 'variant' | 'color' | 'title' | 'className'>

export const useDocumentationURL = (type: DocumentationType): string => {
    const usecase = useAppUsecase('documentationUsecase')
    return useMemo(() => usecase.createURL(type).toString(), [usecase, type])
}

export const DocumentationLink: FC<PropsWithChildren<DocumentationLinkProps>> = ({ type, ...props }) => {
    const href = useDocumentationURL(type)

    return <Link data-testid={`documentation-link-${type.toLowerCase().replaceAll(/_+/g, '-')}`} target="_blank" {...props} href={href} />
}
